export const MAX_SIDEBAR_TAGS = 3;
